import { useChallenges } from '../../../../../redux/reducer/content';
import { isArray } from 'lodash';

function isAchievementCompleted({ progress, quest_trigger_count: target }) {
  const parsedProgress = Number(progress);
  const parsedTarget = Number(target);

  if (Number.isNaN(parsedProgress) || Number.isNaN(parsedTarget) || parsedTarget <= 0) return false;

  return parsedProgress >= parsedTarget;
}

function isAchievementDone(achievement) {
  return !!achievement?.hasIcon || isAchievementCompleted(achievement);
}

function getAchievementGroupKey({ quest_type: questType, title, system_name: systemName }) {
  const normalizedSystemName = typeof systemName === 'string' ? systemName.replace(/\d+$/, '') : '';
  const normalizedTitle = typeof title === 'string' ? title.trim().toLowerCase() : '';

  return `${questType ?? normalizedSystemName}::${normalizedTitle || normalizedSystemName}`;
}

function pickActualAchievementByGroup(achievements = []) {
  const sortedByQuestTrigger = [...achievements].sort(
    (a, b) => Number(a.quest_trigger_count ?? 0) - Number(b.quest_trigger_count ?? 0),
  );
  const nextAchievement = sortedByQuestTrigger.find((achievement) => !isAchievementDone(achievement));

  return nextAchievement ?? sortedByQuestTrigger[sortedByQuestTrigger.length - 1];
}

export default function useFilteredAchieves() {
  const { icons } = useChallenges();

  const filteredIcons = [];

  function recurseSearch(icons) {
    icons.forEach((icon) => {
      const { child, needed_premium } = icon;
      const isCompleted = isAchievementDone(icon);
      if (needed_premium) return;
      if (isCompleted && isArray(child) && !!child?.length) recurseSearch(icon.child);
      else filteredIcons.push(icon);
    });
  }

  recurseSearch(icons);

  const achievementsByGroup = filteredIcons.reduce((acc, achievement) => {
    const key = getAchievementGroupKey(achievement);
    if (!acc[key]) acc[key] = [];
    acc[key].push(achievement);
    return acc;
  }, {});

  const actualAchievements = Object.values(achievementsByGroup).map((group) => pickActualAchievementByGroup(group));

  return actualAchievements.sort((a, b) => {
    const { grade: gradeA, child: childA } = a;
    const { grade: gradeB, child: childB } = b;
    const isCompletedA = isAchievementDone(a);
    const isCompletedB = isAchievementDone(b);
    if (isCompletedA && !childA?.length) return 1;
    if (isCompletedB && !childB?.length) return -1;
    return (gradeB ?? 1) - (gradeA ?? 1);
  });
}
